export default __webpack_public_path__ + "media/assets/img/img_icon_spitzmarke-f20c44867e11a951ba7288216885edfa.svg";